import { Component, ElementRef, OnInit, ViewChild } from "@angular/core";
import { ToastrService } from "ngx-toastr";
import { AuthService } from "../core/auth.service";
import { marked } from "marked";
import TurndownService from "turndown";
import {
  DashboardGestao,
  GestaoService,
  UsuarioGestao,
  OperacaoService,
} from "../gestao.service";
@Component({
  selector: "app-dashboard",
  templateUrl: "./dashboard.component.html",
  styleUrl: "./dashboard.component.css",
  standalone: false,
})
export class DashboardComponent implements OnInit {
  @ViewChild("editorVisual") editorVisual?: ElementRef<HTMLElement>;
  @ViewChild("arquivoImagem") arquivoImagem?: ElementRef<HTMLInputElement>;
  dados: DashboardGestao = {
    empresas: 0,
    usuariosTenant: 0,
    contatos: 0,
    empresasRecentes: [],
  };
  usuarios: UsuarioGestao[] = [];
  aba = "dashboard";
  itens: any[] = [];
  extra: any;
  modal = false;
  edicao: any = {};
  salvando = false;
  modoEditor: "visual" | "html" | "markdown" = "visual";
  conteudoMarkdown = "";
  private conversorMarkdown = new TurndownService();
  private selecaoEditor?: Range;
  constructor(
    private api: GestaoService,
    private op: OperacaoService,
    public auth: AuthService,
    private toast: ToastrService,
  ) {}
  ngOnInit() {
    this.api.dashboard().subscribe((r) => (this.dados = r.dados));
  }
  abrir(a: string) {
    this.aba = a;
    if (a === "gestao")
      this.api.usuarios().subscribe((r) => (this.usuarios = r.dados || []));
    else if (a !== "dashboard")
      this.op.listar(a).subscribe((r) => {
        this.extra = r;
        this.itens = Array.isArray(r) ? r : r.assinaturas || [];
      });
  }
  novo() {
    this.edicao =
      this.aba === "Planos"
        ? { nome: "", descricao: "", preco: "", usuarios: 1, espaco: 1 }
        : this.aba === "Pagamentos"
          ? {
              empresaId: 0,
              descricao: "",
              valor: 0,
              dataVencimento: "",
              boletoUrl: "",
              status: "Pendente",
            }
          : { titulo: "", categoria: "", conteudo: "", slug: "" };
    this.modal = true;
    if (this.aba === "Wiki") this.prepararEditor();
  }
  novoUsuarioGestao() {
    this.edicao = { nome: "", email: "", senha: "" };
    this.modal = true;
  }
  salvarUsuarioGestao() {
    const nome = this.edicao.nome?.trim();
    const email = this.edicao.email?.trim().toLowerCase();
    const senha = this.edicao.senha;
    if (!nome || !email || !senha) {
      this.toast.warning("Preencha nome, e-mail e senha inicial.");
      return;
    }
    if (!email.endsWith("@agenciapublik.com.br")) {
      this.toast.warning("Use um e-mail @agenciapublik.com.br.");
      return;
    }
    if (senha.length < 10) {
      this.toast.warning("A senha inicial deve ter pelo menos 10 caracteres.");
      return;
    }
    this.salvando = true;
    this.api.adicionar({ nome, email, senha }).subscribe({
      next: () => {
        this.salvando = false;
        this.modal = false;
        this.toast.success("Usuário da gestão cadastrado.");
        this.abrir("gestao");
      },
      error: (erro) => {
        this.salvando = false;
        this.toast.error(
          typeof erro.error === "string"
            ? erro.error
            : "Não foi possível cadastrar o usuário.",
        );
      },
    });
  }
  salvarItem() {
    if (this.aba === "Wiki" && this.modoEditor === "markdown")
      this.edicao.conteudo = marked.parse(this.conteudoMarkdown, {
        async: false,
      }) as string;
    this.op.salvar(this.aba, this.edicao, this.edicao.id).subscribe({
      next: () => {
        this.modal = false;
        this.toast.success("Registro salvo.");
        this.abrir(this.aba);
      },
      error: () => this.toast.error("Erro ao salvar."),
    });
  }
  editar(x: any) {
    this.edicao = { ...x };
    this.modal = true;
    if (this.aba === "Wiki") this.prepararEditor();
  }
  remover(x: any) {
    this.op.excluir(this.aba, x.id).subscribe(() => this.abrir(this.aba));
  }
  acao(p: string, m: string) {
    this.op.acao(p).subscribe({
      next: () => this.toast.success(m),
      error: () => this.toast.error("Não foi possível concluir."),
    });
  }
  status(u: UsuarioGestao) {
    this.api.status(u.id, !u.ativo).subscribe(() => this.abrir("gestao"));
  }
  resetarSenha(u: UsuarioGestao) {
    if (!confirm(`Gerar uma senha temporária e enviar para ${u.email}?`))
      return;
    this.api.resetarSenha(u.id).subscribe({
      next: () =>
        this.toast.success("Senha temporária gerada e enviada por e-mail."),
      error: (erro) =>
        this.toast.error(
          typeof erro.error === "string"
            ? erro.error
            : "Não foi possível enviar a nova senha.",
        ),
    });
  }
  private prepararEditor() {
    this.modoEditor = "visual";
    this.conteudoMarkdown = this.conversorMarkdown.turndown(
      this.edicao.conteudo || "",
    );
  }
  alterarModoEditor(modo: "visual" | "html" | "markdown") {
    if (this.modoEditor === "markdown" && modo !== "markdown")
      this.edicao.conteudo = marked.parse(this.conteudoMarkdown, {
        async: false,
      }) as string;
    if (modo === "markdown" && this.modoEditor !== "markdown")
      this.conteudoMarkdown = this.conversorMarkdown.turndown(
        this.edicao.conteudo || "",
      );
    this.modoEditor = modo;
  }
  atualizarConteudoVisual(evento: Event) {
    this.edicao.conteudo = (evento.target as HTMLElement).innerHTML;
  }
  formatarEditor(comando: string, valor?: string) {
    document.execCommand(comando, false, valor);
  }
  salvarSelecaoEditor() {
    const selecao = window.getSelection();
    if (selecao?.rangeCount)
      this.selecaoEditor = selecao.getRangeAt(0).cloneRange();
  }
  inserirImagemUrl() {
    this.salvarSelecaoEditor();
    const url = prompt("Informe a URL pública da imagem:", "https://");
    if (url && url !== "https://") this.inserirImagem(url);
  }
  selecionarImagem() {
    this.salvarSelecaoEditor();
    this.arquivoImagem?.nativeElement.click();
  }
  inserirImagemArquivo(evento: Event) {
    const input = evento.target as HTMLInputElement;
    const arquivo = input.files?.[0];
    if (!arquivo) return;
    if (!arquivo.type.startsWith("image/")) {
      this.toast.warning("Selecione um arquivo de imagem.");
      return;
    }
    const leitor = new FileReader();
    leitor.onload = () => this.inserirImagem(String(leitor.result));
    leitor.readAsDataURL(arquivo);
    input.value = "";
  }
  private inserirImagem(origem: string) {
    const editor = this.editorVisual?.nativeElement;
    if (!editor) return;
    editor.focus();
    const selecao = window.getSelection();
    if (this.selecaoEditor && selecao) {
      selecao.removeAllRanges();
      selecao.addRange(this.selecaoEditor);
    }
    document.execCommand("insertImage", false, origem);
    this.edicao.conteudo = editor.innerHTML;
    this.salvarSelecaoEditor();
  }
}
